import { GetIconsSprites} from '../../common/utils';
import './socialShare.css';
// import { API_URLS } from './../Common/Constant';

SocialShare.version = 1000;

SocialShare.lang = 'en';
SocialShare.langs = [
  'en'
];
SocialShare.setLang = (lang: any) => {
  SocialShare.lang = lang;
}

Object.defineProperty(SocialShare, 'name', {
  writable: true,
  value: 'SocialShare'
});

const encodeUrl = (url: any) => {
  return encodeURIComponent(url); 
}

export function SocialShare(props: any) {
  // const KooAppIcon = `${API_URLS.ST_RESOURCES}/stresources/images/Koop.svg`;
  const shareText = props.shareText ? props.shareText.substring(0, 100) : '';
  



  const showSocialShareNew = (<div className='articalmedia'>

    <ul>
      <li>
        <a className="toFb"
          href={`https://www.facebook.com/sharer.php?u=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`}
          target="_blank">
          {/* <FoontAwesomeIcon icon={faFacebookF} /> */}
           <div className='bg-Facebook_icon_T1' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>

      <li>
        <a className="toTwitter"
          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&amp;url=${props.shareUrl}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faTwitter} /> */}
           <div className='bg-X_icon_T1' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>

      <li>
        <a className="wtsapp"
          href={`https://api.whatsapp.com/send?text=${props.shareUrl}`} target="_blank">
          {/* <FoontAwesomeIcon icon={faWhatsapp} /> */}
           <div className='bg-Whatsapp_icon_T1' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>

      <li>
        <a className="toLinkedin"
          href={`https://www.linkedin.com/sharing/share-offsite?url=${encodeUrl(props.shareUrl)}`} target="_blank">
          {/* <FooontAwesomeIcon icon={faLinkedinIn} /> */}
           <div className='bg-in_icon_T1' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </a>
      </li>

      <li>
        <a className="toPinterest"
          href={`https://in.pinterest.com/pin/create/button?url=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`} target="_blank">
          {/* <FoontAwesomeIcon icon={faPinterestP} /> */}
           <div className='bg-Pinterest_icon_T1' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>

      {/* <li>
        <a className="toTelegram"
          href={`https://telegram.me/share/url?url=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`} target="_blank">
          <FoontAwesomeIcon icon={faTelegram} />
           <div className='bg-Facebook_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
        </a>
      </li>
      <li>

        <a className="toKooApp"
          href={`https://www.kooapp.com/create?title=${props.shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`} target="_blank">
          <img src={KooAppIcon} width={36} height={36} alt="Koo" /></a >
      </li > */}
    </ul >
  </div >);

  return (
    // <>{showSocialShare}</>
    <>{showSocialShareNew}</>
  )
}
